export let DropdownLabelType = function (DropdownLabelType) {
  DropdownLabelType["InnerLabel"] = "innerLabel";
  DropdownLabelType["OuterLabel"] = "outerLabel";
  return DropdownLabelType;
}({});
//# sourceMappingURL=types.js.map